import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const fromDateToHumanReadableText = (date: string | null, timeView: boolean = false) =>
  typeof date === 'string' ? dayjs.utc(date).format(`YYYY-MM-DD${timeView ? ', HH:mm' : ''}`) : 'Нет данных';
